export default __webpack_public_path__ + "DriveTimeVideo.c59bbbc4.mov";